import {OnInit} from "@angular/core";
import {BodyService} from "./body.service";
import {NotificationService} from "./notification.service";
import {JsonApiService} from "../../core/api/json-api.service";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/delay";
import {config} from '../../shared/smartadmin.config';

declare var $: any;


export class BaseGeneral implements OnInit {

  protected datai18n: any ;
  protected optionsHeader = this.bodyService.jwt();
  protected colorWarning = "#C79121";
  protected colorSuccess = "#3276B1";
  protected colorError = "#C46A69";
  protected timeDefault = 5000;
  protected numeroMaximoRecientes: number= 5;


  constructor(protected bodyService: BodyService,
              protected notificationService: NotificationService,
              protected jsonApiService: JsonApiService
  ) {
    let data = localStorage.getItem("datai18n");
    this.datai18n = JSON.parse(data);
    this.verificarSessionExpirada();

  }

  protected setOnConstructor() {}


  ngOnInit() {
    //

  }

  protected verificarSessionExpirada() {
    if (sessionStorage.getItem('expiracion')) {
      let expiracion = sessionStorage.getItem('expiracion');
      if (expiracion == 'S') {
        this.bodyService.showPopupSessionExpirada();
      }
    }
  }


  obtenerObjeto(dt: string) {
    let id = '#' + dt;
    var objeto = $(id);
    return objeto;
  }

  setearObjeto(dt:string) {
    let inputCampo = this.obtenerObjeto(dt);
    let valor = inputCampo[0].value;
    return valor;
  }


  mostrarMensajeError(error: any) {

    this.notificationService.smallBoxError(
        this.datai18n['error.generoError'],
        error);
  }

  mostrarMensajeInsertarOK() {
    this.notificationService.smallBoxOK(
        this.datai18n['registro.insertado.ok'],
        this.datai18n.cerrar5segundos);
  }

  mostrarMensajeModificarOK() {
    this.notificationService.smallBoxOK(
        this.datai18n['registro.actualizado.ok'],
        this.datai18n.cerrar5segundos);
  }

  mostrarMensajeEliminarOK() {
    this.notificationService.smallBoxOK(
        this.datai18n['registro.eliminado.ok'],
        this.datai18n.cerrar5segundos);
  }

  mostrarMensajeValidacion(mensaje: any) {
    this.notificationService.smallBoxWarning(
        this.datai18n['Valitation.growl.title'],
        mensaje);
  }

  optionAdicionalDatatable(dt:string, optionsTable:any) {
    let element = this.obtenerObjeto(dt);
    let options = optionsTable || {}


    let toolbar = '';
    if (options.buttons)
      toolbar += 'B';
    toolbar += 'l';
    toolbar += 'C';

    if (typeof options.ajax === 'string') {
      let url = options.ajax;
      options.ajax = {
        url: url,
        // complete: function (xhr) {
        //
        // }
      }
    }

    options = $.extend(options, {
      // "scrollY": 300,
      // "scrollX": true,
      // responsive: true,
      // oLanguage: {
      //   "sSearch": "<span class='input-group-addon'><i class='glyphicon glyphicon-search'></i></span> ",
      //   "sLengthMenu": "_MENU_"
      // },
      language: {
        url: this.getBaseUrl() + this.getBaseAssetApi() + "/langs/datatable/Spanish.json"
      },

      "dom": "<'dt-toolbar'<'col-xs-12 col-sm-6'f><'col-sm-6 col-xs-12 hidden-xs text-right'" + toolbar + ">r>" +
      "t" +
      "<'dt-toolbar-footer'<'col-sm-6 col-xs-12 hidden-xs'i><'col-xs-12 col-sm-6'p>>",
      autoWidth: true,
      retrieve: true,
      initComplete: (settings, json) => {
        element.parent().find('.input-sm',).removeClass("input-sm").addClass('input-md');
      }
    });


  }

  protected actualizarListaRecientes(codigo: string, descripcion: string, url:string) {

    let lista = sessionStorage.getItem("listaRecientes");
    let listaRecientes = JSON.parse(lista);
    if (listaRecientes == null) {
      listaRecientes = [];
    }
    let nuevo =   {
      codigo: "",
      descripcion: "",
      url: ""
    };
    nuevo.codigo = codigo;
    nuevo.descripcion = descripcion;
    nuevo.url = "#" + url;
    if (listaRecientes.length <= 0) {
      listaRecientes.push(nuevo);
    }
    else {
      let listaDepurar: Array<any> = [];
      for (var item of listaRecientes) {
        if (item.codigo != codigo) {
          listaDepurar.push(item);
        }
      }
      listaRecientes = [];
      listaRecientes = listaDepurar;

      let listaNueva: Array<any> = [];
      let contador = 1;
      listaNueva.push(nuevo);
      for (var item of listaRecientes) {
        if (contador < this.numeroMaximoRecientes) {

          listaNueva.push(item);
        }
        contador++;
      }
      listaRecientes = [];
      listaRecientes = listaNueva;
    }
    sessionStorage.setItem("listaRecientes", JSON.stringify(listaRecientes));
    this.verificarSessionExpirada();
  }

  protected actualizarListaRegistroOK(Opcion: string, descripcion: string) {

    this.verificarSessionExpirada();

  }

  protected actualizarListaRegistroError(Opcion: string, error: any) {

    this.verificarSessionExpirada();

  }

  protected getBaseUrl(){
    return location.protocol + '//' + location.hostname + (location.port ? ':'+location.port : '') + '/'
  }

  protected getBaseAssetApi(){
    return config.API_URL;
  }



}



// WEBPACK FOOTER //
// ./src/app/shared/utils/BaseGeneral.ts